<template>
  <svg width="1em" height="1em" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path
d="M8 44V4H31L40 14.5V44H8Z" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round"
stroke-linejoin="round"
/><path d="M32 14L26 16.9688V31.5" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" /><circle
cx="20.5" cy="31.5" r="5.5" fill="none" stroke="currentColor"
stroke-width="4" stroke-linecap="round" stroke-linejoin="round"
/></svg>
</template>